import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { Story } from './components/Story';
import { Reframe } from './components/Reframe';
import { Experience } from './components/Experience';
import { FuturePacing } from './components/FuturePacing';
import { Testimonials } from './components/Testimonials';
import { Urgency } from './components/Urgency';
import { FAQ } from './components/FAQ';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="font-sans bg-gradient-to-b from-blue-50 to-white text-gray-800" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Benefits data-id="element-4" />
        <HowItWorks data-id="element-5" />
        <Story data-id="element-6" />
        <Reframe data-id="element-7" />
        <Experience data-id="element-8" />
        <FuturePacing data-id="element-9" />
        <Testimonials data-id="element-10" />
        <Urgency data-id="element-11" />
        <CTASection data-id="element-12" />
        <FAQ data-id="element-13" />
      </main>
      <Footer data-id="element-14" />
    </div>;
}